import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { addContact } from "@/redux/rtk/features/CRM/contact/contactSlice";
import {
  useAddLeadSourceMutation,
  useGetLeadSourceQuery,
  useUpdateLeadSourceMutation,
} from "@/redux/rtk/features/leadSource/leadSourceApi";

import { Button, Form, Input } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function UpdateLeadSource({ data, onClose }) {
  const { t } = useTranslation();
  const { id } = data;
  const [form] = Form.useForm();

  const { data: leadSources, isLoading: leadSourceLoading } =
    useGetLeadSourceQuery(id);

  const [updateLeadSource, { isLoading }] = useUpdateLeadSourceMutation();

  const onFinish = async (values) => {
    const formData = {
      ...values,
    };

    const resp = await updateLeadSource({ id, values: formData });
    if (resp.data) {
      form.resetFields();
      onClose();
    }
  };

  useEffect(() => {
    if (leadSources) {
      form.setFieldsValue({
        ...leadSources,
      });
    }
  }, [form, leadSources]);

  return (
    <div className="flex justify-center mt-5">
      <UserPrivateComponent permission="create-leadSource" type="update" comment={t("common.permissionError")}>
        <Form
          className="w-full"
          onFinish={onFinish}
          colon={false}
          layout="vertical"
          initialValues={leadSources}
          form={form}>
          <div className="w-full px-10">
            <Form.Item
              label={t("leadSource.name")}
              name="name"
              rules={[
                { required: true, message: t("leadSource.nameRequired") },
              ]}>
              <Input placeholder={t("leadSource.name")} />
            </Form.Item>
          </div>

          <Form.Item label="" className="px-10">
            <div className="flex items-center gap-2">
              <Button
                size={"large"}
                htmlType="submit"
                type="primary"
                loading={isLoading}>
                {t("common.save")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
